import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-map-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './map-popup.component.html',
  styleUrl: './map-popup.component.scss'
})
export class MapPopupComponent {
  @Input() stage: any;
  rotateButton = false;
  isExpanded = false;

  get processColor(): string {
    switch (this.stage?.processName) {
      case 'Agricultura': return '#368EFA';
      case 'Refinaria': return '#a5dc00';
      case 'Moagem': return '#1e8c08';
      case 'Logísticas de Saída': return '#C92026';
      default: return '#000000';
    }
  }

  rotateAndExpand(): void {
    this.rotateButton = !this.rotateButton;
    this.isExpanded = !this.isExpanded;
  }
}
